// extracted by mini-css-extract-plugin
module.exports = {"cashier":"_df24cfd","wrapper":"_e5e1971","eligible":"_0ab36d3","label":"_26a1554"};